// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LnSc","col":"styles_col__3NB5g"};